import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#F7F3EC] py-20 lg:py-32" id="manifesto" data-testid="manifesto-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <p className="eyebrow-label mb-14">{t.manifesto.eyebrow}</p>
        </Reveal>
        <div className="space-y-0">
          {t.manifesto.chapters.map((ch, i) => (
            <Reveal key={ch.n} delay={i * 0.08}>
              <div className={`grid grid-cols-1 lg:grid-cols-12 gap-6 py-12 lg:py-16 ${i > 0 ? "border-t border-[#191713]/10" : ""}`}>
                <div className="lg:col-span-2">
                  <span className="font-serif text-5xl lg:text-6xl text-[#B8933F]">{ch.n}</span>
                </div>
                <div className="lg:col-span-5">
                  <h3 className="font-serif text-2xl sm:text-3xl text-[#191713] leading-snug">{ch.title}</h3>
                </div>
                <div className="lg:col-span-5">
                  <p className="text-[#191713]/70 leading-relaxed">{ch.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
